import { postApi } from '../../../utils/api'

export function getTemplate(id, data) {
  return postApi({
    data,
    endpoint: `/api/text-module/post-snippet/${id}/render/`,
  })
}

export function createPost(data) {
  return postApi({ data, endpoint: '/api/v2/newsband/' })
}

export function createTvTicker(data) {
  return postApi({ data, endpoint: '/api/ticker-private/' })
}
